// Auto-generated by the generator
// Don't manually edit this file

// @flow

import type {Action} from '../../types'
import type {PlaceState} from '../types'

import {setPlaceReducer} from './setPlace'
import {setPlaceListReducer} from './setPlaceList'
import {setPaginationReducer} from './setPagination'
import {initialState} from './initialState'

export const placeReducer = (state: PlaceState = initialState, action: Action<any>): PlaceState => {
  switch (action.type) {
    case 'place/SET_PLACE':
      return setPlaceReducer(state, action)
    case 'place/SET_PLACE_LIST':
      return setPlaceListReducer(state, action)
    case 'place/SET_PAGINATION':
      return setPaginationReducer(state, action)
    default:
      return state
  }
}
